import { AppState } from "@auth0/auth0-react"
import { navigate } from "@reach/router"
import { useCallback, useMemo } from "react"
import { config as getConfig } from "../../shared/config"

export type Auth0Config = Readonly<{
  onRedirect: (s?: AppState) => void
  clientId: string
  audience: string
  domain: string
}>

// --------------------------------------------------------------------------------------------------------------------

export const getAuth0Config = (appEnv: string, onRedirect: (s?: AppState) => Promise<void>) => {
  switch (appEnv) {
    case `prod`:
      return {
        domain: `auth.flockcover.com`,
        clientId: `emRqBpHYtVx6oHGV6qdGJRz9p5hpyohh`,
        audience: `https://api.flockcover.com`,
        onRedirect,
      }

    case `staging`:
      return {
        domain: `flock-platform-staging.eu.auth0.com`,
        clientId: `YSEieBfFc0NzjEW9DTU75f6y6Xf1pIbm`,
        audience: `https://api.staging.infra.flockcover.com`,
        onRedirect,
      }

    case `dev`:
      return {
        domain: `flock-platform-dev.eu.auth0.com`,
        clientId: `L9p6ZLcjJ42Lm5J3WaD49WD4JIanSUcJ`,
        audience: `https://api.dev.infra.flockcover.com`,
        onRedirect,
      }

    default:
      throw new Error(`Unknown Environment`)
  }
}

// --------------------------------------------------------------------------------------------------------------------

export const useAuth0Config = (): Auth0Config => {
  const { pathname } = window.location
  const config = useMemo(() => getConfig(), [])
  const onRedirect = useCallback((s?: AppState) => navigate(s?.returnTo ?? pathname), [pathname])

  return getAuth0Config(config.appEnv, onRedirect)
}
